import React, { useEffect, useRef, useState } from "react";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Paragraph from "@editorjs/paragraph";
import styles from "../styles/AddProduct.css";

function AddProduct() {
  const [ProductNameEN, setProductNameEN] = useState("");
  const [ProductNameAR, setProductNameAR] = useState("");
  const [Image, setImage] = useState("");
  const [CompanyNameAR, setCompanyNameAR] = useState("");
  const [CompanyNameEN, setCompanyNameEN] = useState("");
  const [editingProductId, setEditingProductId] = useState(null);
  const editorEnglishRef = useRef(null);
  const editorArabicRef = useRef(null);
  const editorEnglishContainerRef = useRef(null);
  const editorArabicContainerRef = useRef(null);
  const [productsList, setProductsList] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); 


  useEffect(() => {
    if (!editorEnglishContainerRef.current || !editorArabicContainerRef.current)
      return;

    const editorEnglish = new EditorJS({
      holder: editorEnglishContainerRef.current,
      tools: { header: Header, list: List, paragraph: Paragraph },
      placeholder: "Write product details in English...",
    });

    const editorArabic = new EditorJS({
      holder: editorArabicContainerRef.current,
      tools: { header: Header, list: List, paragraph: Paragraph },
      placeholder: "اكتب تفاصيل المنتج باللغة العربية...",
    });

    editorEnglishRef.current = editorEnglish;
    editorArabicRef.current = editorArabic;

    return () => {
      if (editorEnglishRef.current) editorEnglishRef.current.destroy();
      if (editorArabicRef.current) editorArabicRef.current.destroy();
    };
  }, []);

  const handleEdit = async (product) => {
    setEditingProductId(product._id);
    setProductNameEN(product.ProductNameEN);
    setProductNameAR(product.ProductNameAR);
    setCompanyNameEN(product.CompanyNameEN);
    setCompanyNameAR(product.CompanyNameAR);
    setImage(product.Image || "");

    if (editorEnglishRef.current && editorArabicRef.current) {
      await editorEnglishRef.current.isReady;
      await editorArabicRef.current.isReady;
      editorEnglishRef.current.render(product.Body?.English || {});
      editorArabicRef.current.render(product.Body?.Arabic || {});
    }
  };
  const handleDelete = async (product) => {
    const response = await fetch(
      `https://cairomed-backend.vercel.app/api/products/deleteProduct/${product._id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
      }
    );
  
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to Delete product");
    }
    getProductList();
    alert("Product Deleted successfully!");
    
  };

  const handleCreateProduct = async (productData) => {
    // Log the JSON data being sent
    console.log("=== Product JSON being sent to API ===");
    console.log(productData);
    
    try {
      const response = await fetch("https://cairomed-backend.vercel.app/api/products/createProduct", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(productData),
      });
      
      console.log("API Create Response Status:", response.status);
      
      const responseData = await response.json();
      console.log("API Response Data:", responseData);
      
      if (!response.ok) {
        throw new Error(responseData.message || "Failed to create product");
      }
      
      alert("Product created successfully!");
      return responseData;
    } catch (error) {
      console.error("Error response:", error);
      alert(`An error occurred: ${error.message}`);
      throw error;
    }
  };

  const handleUpdateProduct = async (productData) => {
    console.log("=== Update Product Data ===");
    console.log("Data being sent:", productData);
    
    try {
      const response = await fetch(
        `https://cairomed-backend.vercel.app/api/products/updateProduct/${editingProductId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(productData),
        }
      );
      
      console.log("API Update Response Status:", response.status);
      
      const responseData = await response.json();
      console.log("API Response Data:", responseData);
      
      if (!response.ok) {
        throw new Error(responseData.message || "Failed to update product");
      }
      
      alert("Product updated successfully!");
      return responseData;
    } catch (error) {
      console.error("Error response:", error);
      alert(`An error occurred: ${error.message}`);
      throw error;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const englishContent = await editorEnglishRef.current.save();
      const arabicContent = await editorArabicRef.current.save();

      const bodyData = {
        English: englishContent,
        Arabic: arabicContent,
      };

      console.log("=== Form Submission Data ===");
      console.log("ProductNameEN:", ProductNameEN);
      console.log("ProductNameAR:", ProductNameAR);
      console.log("CompanyNameEN:", CompanyNameEN);
      console.log("CompanyNameAR:", CompanyNameAR);
      console.log("Body:", bodyData);
      console.log("Image URL:", Image);

      const productData = {
        ProductNameEN,
        ProductNameAR,
        CompanyNameAR,
        CompanyNameEN,
        Body: bodyData,
        Image
      };

      if (editingProductId) {
        await handleUpdateProduct(productData);
      } else {
        await handleCreateProduct(productData);
      }

      setProductNameEN("");
      setProductNameAR("");
      setImage("");
      setCompanyNameAR("");
      setCompanyNameEN("");
      setEditingProductId(null);
      editorEnglishRef.current.clear();
      editorArabicRef.current.clear();
      getProductList();
    } catch (error) {
      console.error("Error:", error);
      alert(`An error occurred: ${error.message}`);
    }
  };

  useEffect(() => {
    getProductList();
  }, []);

  async function getProductList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/products/getProduct"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Products data");
      }
      const filteredData = await response.json();
      setProductsList(filteredData);
      console.log(filteredData);
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  }
  
  const filteredProducts = productsList.filter((product) =>
    `${product.ProductNameEN} ${product.ProductNameAR}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  function  cancelOperation() {
     setProductNameEN("");
      setProductNameAR("");
      setImage("");
      setCompanyNameAR("");
      setCompanyNameEN("");
      setEditingProductId(null);
      editorEnglishRef.current.clear();
      editorArabicRef.current.clear();
  }

  return (
    <>
      <section>
        <div className="container mt-5 addProductContainer d-flex flex-column w-100 align-items-start justify-content-start">
          <h2>Add Product</h2>
          <form
            onSubmit={handleSubmit}
            className="row w-100 px-0 g-4 pt-3 pb-5"
          >
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="ProductNameEN">Product Name (EN)</label>
              <input
                type="text"
                id="ProductNameEN"
                value={ProductNameEN}
                onChange={(e) => setProductNameEN(e.target.value)}
              />
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="ProductNameAR" className="arabic-version">
                اسم المنتج (AR)
              </label>
              <input
                type="text"
                id="ProductNameAR"
                value={ProductNameAR}
                onChange={(e) => setProductNameAR(e.target.value)}
              />
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="CompanyNameEN">Company Name (EN)</label>
              <select
                id="CompanyNameEN"
                value={CompanyNameEN}
                onChange={(e) => setCompanyNameEN(e.target.value)}
                className="form-select"
              >
                <option value="">Select Company</option>
                <option value="Biodream vet">Biodream vet</option>
                <option value="Arabcomed">Arabcomed</option>
                <option value="Mycrofeed">Mycrofeed</option>
              </select>
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="CompanyNameAR" className="arabic-version">
                اسم الشركة (AR)
              </label>
              <select
                id="CompanyNameAR"
                value={CompanyNameAR}
                onChange={(e) => setCompanyNameAR(e.target.value)}
                className="form-select arabic-version"
              >
                <option value="">اختر الشركة</option>
                <option value="بيودريم فيت">بيودريم فيت</option>
                <option value="أرابكوميد">أرابكوميد</option>
                <option value="ميكروفيد">ميكروفيد</option>
              </select>
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label>Product Description (EN)</label>
              <div
                ref={editorEnglishContainerRef}
                className={styles.editor}
              ></div>
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label className="arabic-version">وصف المنتج (AR)</label>
              <div
                ref={editorArabicContainerRef}
                className="arabic-version"
              ></div>
            </div>
            <div className="col-12 d-flex flex-column gap-2">
              <label htmlFor="Image">Image URL</label>
              <input
                type="url"
                id="Image"
                value={Image}
                onChange={(e) => setImage(e.target.value)}
                placeholder="Enter image URL"
              />
            </div>
            <div className="col-12 d-flex flex-row justify-content-between gap-2">
              <button type="submit" className="submit-btn">
                {editingProductId ? "Update Product" : "Submit"}
              </button >
              {
                editingProductId ? <button type="button" className="cancel-btn" onClick={cancelOperation}>
                Cancel
              </button>: <div></div>
              
              }
              
            </div>
          </form>
        </div>
      </section>
      <section>
        <div className="container">
         
          <input
            className="search-input"
            type="text"
            placeholder="Search by name (EN/AR)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Product Name (EN)</th>
                  <th scope="col">Company</th>
                  <th scope="col">Edit</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <tr key={product._id}>
                      <td>{product.ProductNameEN}</td>
                      <td>{product.CompanyNameEN}</td>
                      <td>
                        <button onClick={() => handleEdit(product)} className="table-edite-btn">Edit</button>
                      </td>
                      <td>
                        <button onClick={() => handleDelete(product)} className="table-delete-btn">Delete</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No products found...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}

export default AddProduct;